import { useLocale } from '~/composables/useLocale'
import { MenuLinkFieldsFragment, MainMenuFieldsFragment } from '~/api/graphql/generated'
import { MenuName as StoreMenuName, useMenuStore } from '~/store/menuStore'

export type MenuName = StoreMenuName
export type ElementToFilter = MainMenuFieldsFragment & MenuLinkFieldsFragment & { links: ElementToFilter[] | null }

export interface MenuItem {
  id: string
  url: string
  target: string
  title: string
  isActive: boolean
  items?: MenuItem[]
}

export type Menu = MenuItem[]

export const createItem = (data: ElementToFilter, path: string): MenuItem => ({
  id: `${(data.entity?.id || -1).toString()}-${data.entity?.langcode?.value} `,
  url: data.url?.path || '',
  target: data.attribute || '',
  title: data.label === '<notitle>' ? '‎' : data.label || '',
  isActive: data.url?.path === path,
  ...(data.links ? { items: data.links.map((item) => createItem(item, path)) } : {}),
})

export const useMenu = async (menuName: MenuName) => {
  const route = useRoute()
  const { languageCode } = useLocale()
  const menuStore = useMenuStore()

  // Fetch initial menu data
  await menuStore.fetchMenu(menuName, languageCode.value)

  // Get reactive menu data from store
  const data = menuStore.getMenu(menuName)

  const menu = computed(() => {
    const menuData = data.value
    if (!menuData || !menuData.links) {
      return []
    }

    return menuData.links.map((menuItem) => createItem(menuItem as ElementToFilter, route.path))
  })

  return { menu, data }
}
